module.exports = __webpack_public_path__ + "img/discount-voucher.7ece6a3.svg";